<template>
  <div id="idenusers">
    <div class='labelName'>
      <span v-if="ifGjFlag && labelName">选择的人员为&nbsp;{{labelName}}</span>
    </div>
    <div class="search-form">
      <input type="text" class="form-control" style="float: left;" placeholder="人员名称" v-model=" username">
      <el-button class="btn selectBtn btnSpe" type="button" @click="onSearch">查询</el-button>
    </div>
    <form style="position: relative;">
      <el-form-item label="" v-if="multiple" style="margin-bottom: 0">
        <!-- <el-select v-model="showDataId" multiple placeholder="请选择" class="checkedPerson" disabled>
            <el-option
                    v-for="item in checkPersonData"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
            </el-option>
        </el-select> -->
        <div class="tags">
          <div v-show="oftenCheckPersonData.length !== 0" style="height: 30px;">
            <span style="font-size: 12px;">常用人</span>
          </div>
          <el-tag
              v-for="(tag, index) in oftenCheckPersonData"
              :key="index"
              closable
              :disable-transitions="false"
              style="cursor:pointer"
              @click="oftenFlagBtn(tag)"
              @close="delCheckUsr(tag.orgId)">
            {{ tag.label }}
          </el-tag>
          <div v-show="checkPersonData.length !== 0" style="height: 30px;">
            <span style="font-size: 12px">已选人</span>
          </div>
          <el-tag
              v-for="(tag, index) in checkPersonData"
              :key="index"
              closable
              :disable-transitions="false"
              @close="cancelCallBack(tag)">
            {{ tag.label }}
            <span v-if="label=='作业人' && qyName == '北良公司' && tag.flag=='1'">(主要作业人)</span>
            <span v-if="label=='作业人' && qyName == '北良公司' && tag.flag=='2'">(辅助作业人)</span>
          </el-tag>
        </div>
      </el-form-item>
      <div id="tree">
        <div class="treeview" id="idenuserTree"></div>
      </div>
    </form>
    <el-button class="btn btn-save btnSpe" type="button" @click="save" v-if="multiple">保存</el-button>

    <van-popup v-if="zyrShow" v-model="zyrShow" position="bottom" :style="{ height: '200px' }"
      :close-on-click-overlay="false" @close="closeSel" >
        <!-- <el-radio-group v-model="radioZyr" @change="changeZyr">
          <el-radio label="1">主要作业人</el-radio>
          <el-radio label="2">辅助作业人</el-radio>
        </el-radio-group> -->
        <div class='zyPopup'>
          <van-radio-group v-model="radioZyr" @change="changeZyr">
            <van-radio name="1">主要作业人</van-radio>
            <van-radio name="2">辅助作业人</van-radio>
          </van-radio-group>
        </div>
    </van-popup>
  </div>
</template>
<script>
import '@/assets/js/bootstrap-treeview/bootstrap-treeview.js'

export default {
  name: "checkusertree",
  data() {
    return {
      username: '',
      qyName: sessionStorage.getItem("GCMZ"),
      params: {
        id: '',
      },
      baseUrl: sessionStorage.getItem("baseURL"),
      checkedListText: [],
      treeData: [],     // 树数据
      showData: null,
      showDataId: null,
      showDataFlag: null,
      checkPersonData: [],
      oftenCheckPersonData: [],
      oftenFlag: false,
      userUrl: '',
      labelName: "",
      ifGjFlag: false,
      zyrShow:false,
      radioZyr:null,
      dataZyr:'',
      selOpt:null,
      ifGjFlag:false,
    }
  },
  props: {
    user: Number,
    multiple: Boolean,
    showDataIdTemp: String,
    showFlag: String,
    showDataTemp: String,
    dataUrl: String,
    label: String,
    modelName:String,
    zylb: String,
    xgfzy: String,
  },
  created() {
    if(this.label == '所在部门'){
      this.labelName = '车间有关人员'
    }else if(this.label == '安全管理部门'){
      this.labelName = '安全部有关人员'
    }else if(this.label == '动火审批人'){
      this.labelName = '主管副总经理或副厂长'
    }else if(this.label == '岗位当班班长'){
      this.labelName = '当班班长'
    }else if(this.label == '审核部门'){
      this.labelName = '专业管理部门有关人员'
    }else if(this.label == '审批部门'){
      if(this.zylb == '动土作业'){
        this.labelName = '专业部门有关人员'
      }else if(this.zylb == '断路作业'){
        this.labelName = '专业管理部门有关人员'
      }else{
        this.labelName = '主管厂长或总工程师'
      }
    }else if(this.label == '用电单位'){
      this.labelName = '用电单位有关人员'
    }else if(this.label == '配送电单位'){
      this.labelName = '配送电单位人员'
    }else if(this.label == '完工验收'){
      if(this.zylb == '吊装作业'){
        this.labelName = '作业人、用电人'
      }else{
        this.labelName = '车间人员、作业人员'
      }
    }else if(this.label == '有关部门'){
      this.labelName = '相关部门审核人'
    }else if(this.label == '消防、安全等部门'){
      this.labelName = '部门有关人员'
    }
    if(sessionStorage.getItem('ZYHGSMZ') == '中粮生物科技'){
      let GCMZ = sessionStorage.getItem('GCMZ')
      let arr = ['宿州生化','沫河口工厂','肇东公司','广西公司']
      if(arr.indexOf(GCMZ) > -1){
        this.ifGjFlag = true
      }
    }
    this.initPropsData();
    this.initGrid();
    this.common.updatezIndex();
    this.loadCheckUser();
  },
  methods: {
    onSearch() {
      this.initGrid();
    },
    oftenFlagBtn(tag) {
      if(this.label=='作业人' && this.qyName == '北良公司'){
        this.radioZyr = ''
        this.selOpt = 1
        this.zyrShow = true
        this.dataZyr = tag
      }else{
        this.flagBtn(tag)
      }
    },
    flagBtn(tag){
      let i = 0
      this.checkPersonData.forEach(item => {
        if (item.value === tag.value) {
          i++
        }
      })
      if (i === 0) {
        if (tag.age) {
          if (tag.sex == 0) {
            if (tag.age > 60) {
              this.$message.error('当前人员已超龄，不能进行危险作业');
              return false;
            }
          } else if (tag.sex == 1) {
            if (tag.age > 55) {
              this.$message.error('当前人员已超龄，不能进行危险作业');
              return false;
            }
          }
        }
        if(this.label==='作业人'){
          tag.flag = this.radioZyr
        }
        this.checkPersonData.push(tag)
        this.showDataId.push(tag.value)
        let varsels = $('#idenuserTree').treeview('getUnselected');
        for (let n = 0; n < varsels.length; n++) {
          if (varsels[n].id == tag.value) {
            $('#idenuserTree').treeview('selectNode', [varsels[n].nodeId, {silent: true}]);
          }
        }
      }
    },
    // 初始化props接受的数据
    initPropsData() {
      if (this.dataUrl) {
        this.userUrl = this.dataUrl
      } else {
        this.userUrl = '/user/userAdmin/getUserRelatedUserViewTree'
      }
      //国家表单-所在部门、安全管理部门、动火审批人、岗位当班班长改成过滤了相关方人员的接口
      if(this.xgfzy != "丙类" && this.ifGjFlag && (this.modelName == 'DHZY_ZYSZRY' || this.modelName == 'DHZY_AQGLRY'
        || this.modelName == 'DHZY_DHSPR' || this.modelName == 'DHZY_DHQGWDBBC')){
          this.userUrl = '/user/userAdmin/getUserUserViewTree'
      }
      this.params.id = this.user;      // 获取父页面id
      if (this.showDataIdTemp){
        this.showDataId = this.showDataIdTemp.split(',')
      }else{
        this.showDataId = []
      }
      if (this.showFlag){
        this.showDataFlag = this.showFlag.split(',');
      }else{
        this.showDataFlag = [];
      }
      if (this.showDataTemp) {
        this.showData = this.showDataTemp.split(',');
        if(this.label==='作业人' && this.qyName == '北良公司'){
          this.showData.forEach((v, i) => {
            this.checkPersonData[i] = {
              label: v,
              value: this.showDataId[i],
              flag: this.showDataFlag[i]
            }
          })
        }else{
          this.showData.forEach((v, i) => {
            this.checkPersonData[i] = {
              label: v,
              value: this.showDataId[i]
            }
          })
        }
      } else {
        this.showData = [];
        this.checkPersonData = [];
      }
    },
    //选择作业人性质
    changeZyr(val){
      this.zyrShow = false
      if(this.selOpt == 1){
        let tag = this.dataZyr
        this.flagBtn(tag)
      }else if(this.selOpt == 2){
        let data = this.dataZyr
        this.callBack(data)
      }
    },
    closeSel(){
      this.zyrShow = false
    },
    // 单选和多选相关逻辑
    checkedCallBack(data) {
      if(this.label==='作业人' && this.qyName == '北良公司'){
        this.radioZyr = ''
        this.selOpt = 2
        this.zyrShow = true
        this.dataZyr = data
      }else{
        this.callBack(data)
      }
    },
    callBack(data) {
      if (data.birthday) {
        let myDate = new Date();
        //获取当前年
        let year = myDate.getFullYear();
        let birYear = Number(data.birthday.substring(0, 4))
        let num = year - birYear
        if (data.sex == 0) {
          if (num > 60) {
            $('#idenuserTree').treeview('unselectNode', [data.nodeId, {silent: false}]);
            this.$message.error('当前人员已超龄，不能进行危险作业');
            return false;
          }
        } else if (data.sex == 1) {
          if (num > 55) {
            $('#idenuserTree').treeview('unselectNode', [data.nodeId, {silent: false}]);
            this.$message.error('当前人员已超龄，不能进行危险作业');
            return false;
          }
        }
      }
      //如果是监督人、作业人判断是否有审核资质及相应证书
      let type = this.$store.state.zylbName;
      let _this = this
      if (this.label==='作业人'|| this.label === '监督人'){
        let param = {
          type:type,
          titleName:this.label,
          userId:data.id
        }
        this.$axios.post(_this.baseUrl + '/user/userAdmin/checkUserCert', param).then(
            (res) => {
              if (res.data.code !== 1){
                $('#idenuserTree').treeview('unselectNode', [data.nodeId, {silent: false}]);
                _this.$message.error(res.data.message);
                return false;
              }
            })
      }
      if (data.type == 'user') {
        if (!this.multiple) {
          let relatedId = null;
          if (data.isRelated == '4') {
            relatedId = data.departId
          }
          let num = data.text.indexOf("(");
          if (num !== -1) {
            let name = data.text.substring(0, num);
            this.$parent.$parent.setTreePeople(data.id, name, relatedId, this.params.id);
          } else {
            this.$parent.$parent.setTreePeople(data.id, data.text, relatedId, this.params.id);
          }
          this.$parent.$parent.show = false;  //关闭当前层
        } else {
          this.checkPersonData.push({
            label: data.text,
            value: data.id,
            isRelated: data.isRelated,
            departId: data.departId,
            nodeId: data.nodeId,
            flag: this.radioZyr
          });
          this.showDataId.push(data.id);
        }
      } else {
        this.$layer.msg('请选择正确的用户');
      }
    },

    // 多选节点取消选中回调
    cancelCallBack(data) {
      if ('id' in data) {  //点击树状结构无效选中效果
        this.checkPersonData = this.checkPersonData.filter(v => v.value !== data.id);
        this.showDataId = this.showDataId.filter(v => v !== data.id);
      } else { //点击按钮关闭标签取消选中效果
        this.checkPersonData = this.checkPersonData.filter(v => v.value !== data.value);
        this.showDataId = this.showDataId.filter(v => v !== data.value);
        let varsels = $('#idenuserTree').treeview('getSelected');
        for (let i = 0; i < varsels.length; i++) {
          if (varsels[i].id == data.value) {
            $('#idenuserTree').treeview('unselectNode', [varsels[i].nodeId, {silent: false}]);
          }
        }
      }
      // this.checkPersonData = this.checkPersonData.filter(v => v.value !== data.id);
      // this.showDataId = this.showDataId.filter(v => v !== data.id);
    },

    // 保存数据
    save() {
      let isRelatedIds = [];
      let flag = []
      if(this.ifGjFlag && (this.label=='交底人' || this.label=='监护人')){
        let qyUser = false
        this.checkPersonData.forEach((item) => {
          if(item.isRelated != '4'){
            qyUser = true
          }
        })
        if(!qyUser && this.xgfzy != '丙类'){
          this.$message({
            message:'要有企业内部人员！',
            type:'error'
          })
          return false;
        }
      }
      this.checkedListText = this.checkPersonData.map(x => {
        if (x.isRelated == '4') {
          isRelatedIds.push(x.departId);
        }
        flag.push(x.flag)
        let num = x.label.indexOf("(");
        if (num > -1) {
          return x.label.substring(0, num);
        } else {
          return x.label;
        }
      }).join();
      this.addCheckUsr()
      if(this.checkedListText){
        this.$parent.$parent.setTreePeople(this.showDataId.join(), this.checkedListText, isRelatedIds.join(), this.params.id, flag.join());
        this.$parent.$parent.show = false; //关闭当前层
      }else{
        this.$message.error('请先选择人员');
      }
    },

    // 初始化默认选中节点
    initCheckedData(res) {
      if (res?.length && this.showDataId?.length) {
        let flag = false;
        res.forEach(v => {
          if (this.isPerson(v.nodes)) {
            flag = true;
            this.eachTree(v.nodes);
          }
        });
        if (!flag) this.eachTree(res);
      }
      return res;
    },

    // 节点nodes判断是否是人员
    isPerson(list) {
      if (!list || !list.length) return false;
      this.initCheckedData(list);
      return true;
    },

    // 遍历树寻找选中树节点值
    eachTree(list) {
      for (let i = 0; i < list.length; i++) {
        for (let j = 0; j < this.showDataId.length; j++) {
          if (list[i].id === this.showDataId[j]) {
            let item = list[i].state = {};
            item.checked = true;
            item.selected = true;
            break;
          }
        }
      }
    },
    loadCheckUser() {
      let _this = this
      this.$axios.post(_this.baseUrl + '/dform/checkUser/getCheckUserListById', null).then(
          (res) => {
            if (res.data.code === 1){
              _this.oftenCheckPersonData = res.data.data
            }
          })
    },
    delCheckUsr(orgId){
      let param = {
        orgId : orgId
      }
      let _this = this
      this.$axios.post(_this.baseUrl + '/dform/checkUser/delCheckUser', param).then(
          (res) => {
            if (res.data.code === 1){
              _this.loadCheckUser()
            }
          })
    },
    addCheckUsr(){
      let _this = this
      this.$axios.post(_this.baseUrl + '/dform/checkUser/addCheckUser', _this.checkPersonData).then(
          (res) => {
            if (res.data.code === 1){
            }
          })
    },
    // 初始化树结构
    initGrid: function () {
      let obj = {};
      obj.username = this.username;
      obj.qyName = this.qyName;
      obj.jobName = this.$store.state.xgfqyName
      this.$axios.post(this.baseUrl + this.userUrl, obj).then(
          (res) => {
            let that = this;
            let result = this.initCheckedData(res.data.data);
            $('#idenuserTree').treeview({
              data: result,
              multiSelect: that.multiple,
              onNodeSelected: function (event, data) {
                that.checkedCallBack(data);
              },
              onNodeUnselected: function (event, data) {
                that.cancelCallBack(data);
              }
            });
          })
    },
  },
  mounted() {
    let _that = this
    if(sessionStorage.getItem('ZYHGSMZ') == '中粮生物科技'){
      let GCMZ = sessionStorage.getItem('GCMZ')
      let arr = ['宿州生化','沫河口工厂','肇东公司','广西公司']
      if(arr.indexOf(GCMZ) > -1){
        _that.ifGjFlag = true
      }
    }
  }
}
</script>

<style scoped>
.zyPopup >>> .van-radio{
  display: flex;
  justify-content: center;
  padding: 20px;
  width: 90%;
  margin: 20px auto;
  border: 1px solid #ddd;
  border-radius: 5px;
}
.labelName{
  color: red;
  margin-bottom: 5px;
}
.tags >>> .el-tag {
  margin-right: 8px;
}

#idenusers {
  /* max-height: 10rem; */
  margin-bottom: .5rem;
}

.form-control {
  -webkit-box-shadow: none;
  box-shadow: none;
  border-radius: 3px;
  border: 1px solid #ccc;
}

.form-control {
  border: 1px solid #ddd;
}

.search-form {
  width: 100%;
  display: flex;
}

.form-control {
  width: 85%;
  height: 40px;
  padding-left: 6px;
  /* padding: 6px 12px; */
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  -webkit-transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
}

.btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 400;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  -ms-touch-action: manipulation;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  padding: 6px 18px;
  font-size: 14px;
  line-height: 1.42857143;
  border-radius: 4px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  color: #fff;
  background: #05469c;
  border: none;
}

.btn-save {
  position: absolute;
  left: calc(50% - 17px);
  bottom: 10px;
  margin: auto 0;
}

.checkedPerson {
  width: 100%;
  overflow: hidden;
}

#idenusers .search-form input {
  border-top-right-radius: 0px;
  border-bottom-right-radius: 0px;
}

#idenusers .search-form .btn {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  /* background: linear-gradient(45deg, #46b6e9, #05469c); */
}

#idenuserTree {
  max-height: 7rem;
  padding-bottom: 10px;
  overflow: auto;
}

#idenuserTree >>> .list-group {
  /* border: 1px solid #ddd; */
}
#idenuserTree >>> .list-group li.list-group-item{
  padding: 3px 4px;
}

#idenuserTree >>> li {
  line-height: 30px;
}
#tree >>> .expand-icon{
  font-family: element-icons!important;
  speak: none;
  font-style: normal;
  font-weight: 400;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
#tree >>> .icon.expand-icon.glyphicon.glyphicon-chevron-right:before {
  content: '\e6e0';
  /* display: block; */
  width: 16px;
  height: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #666;
}
#tree >>> .icon.expand-icon.glyphicon.glyphicon-chevron-down{
  transform: rotate(90deg);
}
#tree >>> .icon.expand-icon.glyphicon.glyphicon-chevron-down:before{
  content: '\e6e0';
  /* display: block; */
  width: 16px;
  height: 16px;
  font-size: 18px;
  font-weight: bold;
  color: #666;
}
</style>
